import React from 'react'

const AboutForm = () => {
  return (
    <div>
        <form>
                

                <textarea name="" id="" cols="30" rows="10" placeholder='About me'></textarea>

                <input type="submit" value="UPDATE"  className='update'/>

            
            
            </form>
    </div>
  )
}

export default AboutForm